export default __webpack_public_path__ + "static/media/mentorship_icon3.4e5a2196.svg";